<template>
  <panel float class="flex flex-col" :height="panelHeight">
    <div class="head">
      <div @click="togglePanelHeight" class="arrow" :class="{ down: panelExpanded }">
        <img src="../../assets/common/arrow.svg" alt="Toggle" />
      </div>
      <div>{{ $t('footscan.analysis') }}</div>
    </div>
    <tabs class="flex flex-col flex-1" v-model="activeTab">
      <tab :title="$t('footscan.tab__fit')">
        <div class="tab-wrapper">
          <measurement-row v-bind="makeRowProps(0)" v-on="makeListener(0)" />
        </div>
      </tab>
      <tab :title="$t('footscan.tab__width')">
        <div class="tab-wrapper">
          <measurement-row v-bind="makeRowProps(1)" v-on="makeListener(1)" />
        </div>
      </tab>
      <tab :title="$t('footscan.tab__arches')">
        <div class="tab-wrapper">
          <measurement-row v-bind="makeRowProps(2)" v-on="makeListener(2)" />
          <arch-type :measurement="measurements[2]" />
        </div>
      </tab>
      <tab :title="$t('footscan.tab__measure')">
        <div class="tab-wrapper">
          <measurement-row v-bind="makeRowProps(3)" v-on="makeListener(3)" />
          <measurement-row v-bind="makeRowProps(4)" v-on="makeListener(4)" />
          <measurement-row v-bind="makeRowProps(5)" v-on="makeListener(5)" />
        </div>
      </tab>
      <tab :title="$t('footscan.tab__type')">
        <div class="tab-wrapper">
          <foot-type :measurement="measurements[6]" />
        </div>
      </tab>
    </tabs>
  </panel>
</template>

<script>
import Panel from '@/components/common/Panel.vue';
import Tabs from '@/components/common/Tabs.vue';
import Tab from '@/components/common/Tab.vue';
import MeasurementRow from '@/components/FootScan/MeasurementRow.vue';
import ArchType from '@/components/FootScan/ArchType.vue';
import FootType from '@/components/FootScan/FootType.vue';

export default {
  name: 'AnalysisPanel',
  components: {
    Panel,
    Tabs,
    Tab,
    MeasurementRow,
    ArchType,
    FootType,
  },
  props: {
    measurements: {
      type: Array,
      default: () => [],
    },
    activeIndex: Number,
    useInch: Boolean,
  },
  data: () => ({
    activeTab: 0,
    panelHeight: '50%',
  }),
  methods: {
    isActive(index) {
      return this.activeIndex === index;
    },
    makeRowProps(index) {
      return {
        measurement: this.measurements[index],
        useInch: this.useInch,
        active: this.isActive(index),
      };
    },
    makeListener(index) {
      return {
        'set-active': () => this.setActive(index),
        toggle: leftOrRight => this.toggle(index, leftOrRight),
      };
    },
    setActive(index) {
      this.$emit('set-active', index);
    },
    toggle(index, leftOrRight) {
      this.$emit('toggle', index, leftOrRight);
    },
    togglePanelHeight() {
      this.panelHeight = this.panelHeight === '50%' ? '90%' : '50%';
    },
  },
  computed: {
    panelExpanded() {
      return this.panelHeight === '90%';
    },
  },
  watch: {
    activeTab(nv) {
      this.setActive(nv === 4 ? 6 : nv);
    },
  },
};
</script>

<style lang="scss" scoped>
.head {
  @apply px-4 py-3 text-center font-semibold flex flex-col items-center;
  font-size: 14px;
  color: #262626;
  .arrow {
    @apply mx-auto;
    &.down img {
      transform: rotateX(180deg);
      transform-origin: 0 3px;
    }
  }
}
.tab-wrapper {
  @apply flex flex-col flex-1 px-4 pt-4 items-center;
  .row-wrapper {
    @apply my-2;
  }
}
</style>
